import * as React from "react";

const IconArrowDropdownSmall: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="4" viewBox="0 0 7 4">
            <path
                fill="currentColor"
                d="M16.8078262,1.13750013 L14.0217165,3.80416679 C13.86608,3.93541654 13.6863311,4 13.5065822,4 C13.3268332,4 13.1475225,3.93489583 13.0105186,3.8046875 L10.2244089,1.13802083 C10.0042034,0.947916667 9.94413209,0.660416603 10.0527267,0.412500064 C10.1613213,0.164583524 10.41731,0 10.7007437,0 L16.2926915,0 C16.5763443,0 16.8323769,0.162104289 16.9411029,0.411458333 C17.049829,0.660812378 17.0094951,0.947916667 16.8078259,1.13750013 L16.8078262,1.13750013 Z"
                transform="matrix(1 0 0 -1 -10 4)"
            />
        </svg>
    );
};

export default React.memo(IconArrowDropdownSmall);
